import { findCategoryNodeForShopSlug } from './shopCategoryApiResolve';

/**
 * Horizontal “related categories” pills for `/shop/:category` — driven by GET /categories tree
 * (same records `buildShopProductApiParams` uses), not static BROWSE_PILLS.
 *
 * @param {string} shopSegment - route param e.g. `women`, `men`, `knitwear`
 * @param {unknown[]} roots - Redux `category.roots`
 * @returns {{ slug: string, label: string, thumb?: string }[]}
 */
export function buildShopBrowsePillsFromCategoryTree(shopSegment, roots) {
  const seg = String(shopSegment || '').toLowerCase().trim();
  if (!seg || seg === 'all' || seg === 'sale' || seg === 'bestsellers') return [];

  const node = findCategoryNodeForShopSlug(Array.isArray(roots) ? roots : [], seg);
  if (!node || typeof node !== 'object' || !Array.isArray(node.children) || node.children.length === 0) {
    return [];
  }

  const out = [];
  for (const c of node.children) {
    if (!c || typeof c !== 'object' || c.isActive === false) continue;
    const slug = String(c.slug || '').trim();
    if (!slug) continue;
    if (slug.toLowerCase() === seg) continue;
    const label = (c.name != null && String(c.name).trim()) || slug;
    const img = typeof c.image === 'string' ? c.image.trim() : '';
    const thumb = img && (img.startsWith('http') || img.startsWith('data:')) ? img : undefined;
    out.push({ slug, label, thumb });
  }
  return out;
}
